import { Building2 } from 'lucide-react';
import type { ReactNode } from 'react';
import { UI_TEXT } from '@/shared/languages';
import { ResultScreen } from './result-screen';

export interface NoPlantsStateProps {
  /** 하단 액션(선택) — "발전소 등록/문의" 등. 기본 없음(정보성). */
  action?: ReactNode;
}

/**
 * 발전소 없음 표준 풀페이지 상태 — 발전소-스코프 페이지(인버터·통계·수익 등)가 접근 가능한 발전소 0개일 때.
 * `ResultScreen`(404/503/결제결과와 동일 3슬롯) 위 캐논 텍스트 1벌 — 페이지마다 문구 중복하지 않는다.
 * 국소 0건(특정 발전소 안 데이터 없음)은 `EmptyState`(인라인)가 담당 — 역할 구분.
 */
export function NoPlantsState({ action }: NoPlantsStateProps) {
  return (
    <ResultScreen
      title={UI_TEXT.COMMON_NO_PLANTS_TITLE}
      description={UI_TEXT.COMMON_NO_PLANTS_DESC}
      icon={Building2}
      align="center"
      actions={action}
    />
  );
}
